export const getUriFromCategoryKey = (categoryKey: string) =>
  categoryKey.toLowerCase().replace(/_/g, '-');
